import { RouteRecordRaw } from 'vue-router'

const Accounts = () =>
  import(/* webpackChunkName: "accounts-view" */ './pages/index.vue')

const AccountShow = () =>
  import(/* webpackChunkName: "accounts-show" */ './pages/ShowPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'clientes',
    name: 'accounts-clients',
    component: Accounts,
    props: { kind: 'client' },
    meta: {
      title: 'Clientes',
      auth: {
        requiredPermission: 'accounts.view',
        requiredModule: 'accounts',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'clientes/:ulid',
    name: 'accounts-clients-show',
    component: AccountShow,
    props: { kind: 'client' },
    meta: {
      title: 'Cliente',
      auth: {
        requiredPermission: 'accounts.view',
        requiredModule: 'accounts',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'proveedores',
    name: 'accounts-suppliers',
    component: Accounts,
    props: { kind: 'supplier' },
    meta: {
      title: 'Proveedores',
      auth: {
        requiredPermission: 'accounts.view',
        requiredModule: 'accounts',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'proveedores/:ulid',
    name: 'accounts-suppliers-show',
    component: AccountShow,
    props: { kind: 'supplier' },
    meta: {
      title: 'Proveedor',
      auth: {
        requiredPermission: 'accounts.view',
        requiredModule: 'accounts',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
